import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export interface IWorkbenchLayoutS {
  layout: any,
}

@Module({ dynamic: true, store, name: 'workbenchlayoutsser' })
class WorkbenchLayout extends VuexModule {
    public layout:any = sessionStorage.getItem('store') && JSON.parse(sessionStorage.getItem('store') as string).workbenchlayouts ? JSON.parse(sessionStorage.getItem('store') as string).workbenchlayouts.layout : []
    getModule: any;
    get getLayouts() {
      return this.layout;
    }
    @Mutation
    private SET_LAYOUT(layout: any) {
      this.layout = layout;
    }
    @Action
    public async setLayout(layout: any) {
      this.SET_LAYOUT(layout);
    }
}
export const WorkbenchLayoutModules = getModule(WorkbenchLayout);
